import Tracked from '~/components/Tracked';
import type { TrackedButtonClickName } from '~/services/gtm.client';

export interface MenuLinkProps {
  link: string;
  onClick?: () => void;
  pagePosition?: string;
  title: string;
  track?: boolean;
}

export default function MenuLink({ title, link, onClick }: MenuLinkProps) {
  return (
    <Tracked.ExternalLink
      href={link}
      name={title as TrackedButtonClickName}
      variant="none"
      className="flex h-7 w-fit items-center justify-center rounded-full border border-grey-divide px-5 py-1 text-xs text-black hover:border-black hover:bg-black hover:text-white"
      pagePosition="Header"
      onClick={onClick}
    >
      {title}
    </Tracked.ExternalLink>
  );
}
